import type { AuthValue } from '@elfsight/configurator-contracts';
import type { DemoSourceType } from '../types';
import type { FacebookSourceValue } from './types';

const previewFacebookAuth: AuthValue = {
  identity: '245845f7-5637-45c4-b137-21f6e2bc07d6',
  data: { name: 'Макс Исаев' },
  status: 'connected'
};

export const previewFacebookSources: DemoSourceType<FacebookSourceValue> = {
  'facebook-daniella-bakery': {
    label: 'Facebook: @DaniellaBakery',
    source: {
      platform: 'facebook',
      connectionType: 'facebookPage',
      id: 'kmc51oun',
      name: 'Facebook',
      authentication: previewFacebookAuth,
      source: {
        identity: '101248725390688',
        status: 'connected',
        data: {
          id: '101248725390688',
          name: 'Daniella Bakery',
          link: 'https://www.facebook.com/101248725390688',
          pictureURL:
            'https://scontent-lax3-1.xx.fbcdn.net/v/t39.30808-1/303094565_449954183860424_2726279966074244516_n.jpg?stp=c2.0.50.50a_cp0_dst-jpg_p50x50&_nc_cat=105&ccb=1-7&_nc_sid=4da83f&_nc_ohc=sZFqRtSHS4sAX9VArYy&_nc_ht=scontent-lax3-1.xx&edm=AGaHXAAEAAAA&oh=00_AfDPKiM2ems4H0qG-z_mt92ZNJd1M--Jo4-QlPlnbQDXBg&oe=65C0088B'
        }
      }
    }
  },
  'facebook-elfsight': {
    label: 'Facebook: @Elfsight',
    source: {
      platform: 'facebook',
      connectionType: 'facebookPage',
      id: 'kgj2xfdb',
      name: 'Facebook',
      authentication: previewFacebookAuth,
      source: {
        identity: '555426387893210',
        status: 'connected',
        data: {
          id: '555426387893210',
          name: 'Elfsight',
          link: 'https://www.facebook.com/555426387893210',
          pictureURL:
            'https://scontent-lax3-2.xx.fbcdn.net/v/t39.30808-1/327235456_1240611859877649_5857944375330470326_n.png?stp=cp0_dst-png_p50x50&_nc_cat=103&ccb=1-7&_nc_sid=4da83f&_nc_ohc=vYoydTRdAoMAX-LRU_l&_nc_ht=scontent-lax3-2.xx&edm=AGaHXAAEAAAA&oh=00_AfCOko9bGJCYJhl0D_Om_yrowODesnPr78M1kU_YkaQ4iA&oe=65C0CC88'
        }
      }
    }
  }
};
